exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".documents-chain[data-v-d0c570b6]{cursor:pointer;color:#398edd}.status[data-v-d0c570b6]{position:relative}.status[data-v-d0c570b6]:before{position:absolute;top:4px;left:-15px;content:\"\";width:8px;height:8px;border-radius:50%}.status--gray[data-v-d0c570b6]:before{background:#888484}.status--orange[data-v-d0c570b6]:before{background:#fa0}.status--blue[data-v-d0c570b6]:before{background:#398edd}.status--green[data-v-d0c570b6]:before{background:#1cd66b}.status--red[data-v-d0c570b6]:before{background:#e01515}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d0c570b6","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/ActsList/ActsListTable.vue
// module id = oDZH
// module chunks = 0